/**
 * @author - Andy Howell
 */

(function() {
    angular.module('vhols-ratings', [])

        .directive('vRating', [function() {
            var halfPoints =  /\.5|\+/; // Matches .5 and +

            var ratingMapping = {
                "NA": "villa",
                "VILLAS": "villa"
            };

            function ratingStringify(score) {
                var mappedRating = ratingMapping[score.toUpperCase()] || score;

                return mappedRating.replace(halfPoints, "-plus").toLowerCase();
            }

            return {
                scope: {
                    score: "@"
                },
                link: function($scope, $elem, $attrs) {
                    var prefix = 'rating-';

                    $scope.className = $attrs.className || 'hotel-rating';

                    $scope.$on('$destroy', $scope.$watch('score', function(value) {
                        if (value) {
                            var normalRating = ratingStringify(value);

                            $scope.result = prefix + normalRating;
                        }

                        $scope.hidden = !value;
                    }));
                },
                template: '<div class="{{className}} {{result}}"></div>'
            }
        }]);
})();

